"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
var _admin = require("@/store/modules/admin");
var _index = _interopRequireDefault(require("@/components/Inr/index.vue"));
var _utils = require("@/utils");
var _leads = require("@/api/leads");
var _clientsContacts = require("@/api/clients-contacts");
var _admins = require("@/api/admins");
var _followUps = require("@/api/follow-ups");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.startDate = '';
    this.endDate = '';
    this.clientCount = 0;
    this.clientApprovalCount = 0;
    this.leadCount = 0;
    this.leadWonCount = 0;
    this.leadLostCount = 0;
    this.leadOpenCount = 0;
    this.leadNoFollowUpCount = 0;
    this.leadMissedFollowUpCount = 0;
    this.sampleSentCount = 0;
    this.presentationSentCount = 0;
    this.quoteSentCount = 0;
    this.myPoints = 0;
    this.followUpApprovalCount = 0;
    this.isUserSuperAdmin = true;
    this.isUserAdminOrSuperAdmin = false;
    this.isDispatcher = false;
  }
  onDateRangeChanged(newValue) {
    this.updateDateRange(newValue);
  }
  onSelectedAdminIdChanged(newValue) {
    this.updateDateRange(newValue);
  }
  created() {
    this.showCard();
    this.updateDateRange(this.dateRange);
  }
  updateDateRange(dateRange) {
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.startDate = this.dateRange.start;
      this.endDate = this.dateRange.end;
      this.fetchLeadsCount();
      this.fetchSuperAdminApprovalFollowupssCount();
      this.fetchClientsCount();
      this.fetchApprovalClientsCount();
      this.fetchLeadsWonCount();
      this.fetchLeadsLostCount();
      this.fetchLeadsOpenCount();
      this.fetchLeadsNoFollowUpCount();
      this.fetchLeadsMissedFollowUpCount();
      this.fetchSampleSentCount();
      this.fetchPresentationSentCount();
      this.fetchQuoteSentCount();
      this.fetchMyPoints();
    }
  }
  async showCard() {
    const admin = _admin.AdminModule;
    this.isUserSuperAdmin = admin.roles.includes('Super Admin') || admin.roles.includes('System Admin');
    this.isUserAdminOrSuperAdmin = admin.roles.includes('Super Admin') || admin.roles.includes('Admin') || admin.roles.includes('System Admin');
    this.isDispatcher = admin.roles.includes('Dispatcher');
  }
  async fetchClientsCount() {
    try {
      this.clientCount = +(await (0, _clientsContacts.getClientsContactCount)((0, _utils.getQuery)({
        startDate: this.startDate,
        endDate: this.endDate,
        adminId: this.selectedAdminId
      })));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchApprovalClientsCount() {
    try {
      this.clientApprovalCount = +(await (0, _clientsContacts.getClientsContactApprovalCount)());
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchLeadsCount() {
    try {
      const response = await (0, _leads.getLeadsCount)((0, _utils.getQuery)({
        startDate: this.startDate,
        endDate: this.endDate,
        adminId: this.selectedAdminId
      }));
      this.leadCount = +response;
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchSuperAdminApprovalFollowupssCount() {
    try {
      const response = await (0, _followUps.getFollowUpsCount)((0, _utils.getQuery)({
        status: 'Pending',
        startDate: this.startDate,
        endDate: this.endDate,
        isSuperAdminTask: true
      }));
      this.followUpApprovalCount = +response;
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchLeadsWonCount() {
    try {
      this.leadWonCount = +(await (0, _leads.getLeadsCount)((0, _utils.getQuery)({
        status: 'Won',
        startDate: this.startDate,
        endDate: this.endDate,
        adminId: this.selectedAdminId
      })));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchLeadsLostCount() {
    try {
      this.leadLostCount = +(await (0, _leads.getLeadsCount)((0, _utils.getQuery)({
        status: 'Lost',
        startDate: this.startDate,
        endDate: this.endDate,
        adminId: this.selectedAdminId
      })));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchLeadsOpenCount() {
    try {
      this.leadOpenCount = +(await (0, _leads.getLeadsCount)((0, _utils.getQuery)({
        statuses: ['New', 'Contacted'],
        startDate: this.startDate,
        endDate: this.endDate,
        adminId: this.selectedAdminId
      })));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchLeadsNoFollowUpCount() {
    try {
      this.leadNoFollowUpCount = +(await (0, _leads.getLeadsCount)((0, _utils.getQuery)({
        noFollowup: true,
        startDate: this.startDate,
        endDate: this.endDate,
        adminId: this.selectedAdminId
      })));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchLeadsMissedFollowUpCount() {
    try {
      this.leadMissedFollowUpCount = +(await (0, _leads.getLeadsCount)((0, _utils.getQuery)({
        missedFollowUp: true,
        startDate: this.startDate,
        endDate: this.endDate,
        adminId: this.selectedAdminId
      })));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchSampleSentCount() {
    try {
      this.sampleSentCount = +(await (0, _leads.getLeadsCount)((0, _utils.getQuery)({
        isSampleSent: true,
        startDate: this.startDate,
        endDate: this.endDate,
        adminId: this.selectedAdminId
      })));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchPresentationSentCount() {
    try {
      this.presentationSentCount = +(await (0, _leads.getLeadsCount)((0, _utils.getQuery)({
        isPresentationSent: true,
        startDate: this.startDate,
        endDate: this.endDate,
        adminId: this.selectedAdminId
      })));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchQuoteSentCount() {
    try {
      this.quoteSentCount = +(await (0, _leads.getLeadsCount)((0, _utils.getQuery)({
        isQuotationSent: true,
        startDate: this.startDate,
        endDate: this.endDate,
        adminId: this.selectedAdminId
      })));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchMyPoints() {
    try {
      const response = await (0, _admins.getAdminById)(this.selectedAdminId || _admin.AdminModule.id);
      this.myPoints = response.lifeTimePoints;
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async dateval() {}
  isSuperAdmin() {
    return _admin.AdminModule.roles.indexOf('Super Admin') > -1;
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: []
})], default_1.prototype, "dateRange", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: undefined
})], default_1.prototype, "selectedAdminId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('dateRange', {
  deep: true
})], default_1.prototype, "onDateRangeChanged", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('selectedAdminId', {
  deep: true
})], default_1.prototype, "onSelectedAdminIdChanged", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'PanelGroup',
  components: {
    CountTo: _vueCountTo.default,
    Inr: _index.default
  }
})], default_1);
var _default = exports.default = default_1;